module.exports = __webpack_public_path__ + "img/current-location.bb7242c9.svg";